var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCashbackIndicator = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 185,
  fill: "none",
  viewBox: "0 0 888 185"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#27262B",
  fillOpacity: 0.4,
  d: "M0 160.344V184h888V0h-60.059C736.96 92.035 400.79 160.344 0 160.344"
})), /*#__PURE__*/React.createElement("mask", {
  id: "cashback-indicator_svg__b",
  width: 888,
  height: 184,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashback-indicator_svg__a)",
  d: "M0 160.344V184h888V0h-60.059C736.96 92.035 400.79 160.344 0 160.344"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  fillOpacity: 0.1,
  mask: "url(#cashback-indicator_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43.45 0h1v184h-1zM87.9 0h1v184h-1zM132.35 0h1v184h-1zM176.8 0h1v184h-1zM221.25 0h1v184h-1zM265.7 0h1v184h-1zM310.15 0h1v184h-1zM354.6 0h1v184h-1zM399.05 0h1v184h-1zM443.5 0h1v184h-1zM487.95 0h1v184h-1zM532.4 0h1v184h-1zM576.85 0h1v184h-1zM621.3 0h1v184h-1zM665.75 0h1v184h-1zM710.2 0h1v184h-1zM754.65 0h1v184h-1zM799.1 0h1v184h-1zM843.55 0h1v184h-1z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "cashback-indicator_svg__a",
  x1: 0,
  x2: 0,
  y1: 0,
  y2: 184,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#131315"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#131315",
  stopOpacity: 0.4
})))));
export default SvgCashbackIndicator;